export default "__VITE_ASSET__D1viGkh0__"